module.exports = require("!!vue-loader!../../../node_modules/vue-markdown-loader/lib/markdown-compiler.js?raw!./notice.md");


//////////////////
// WEBPACK FOOTER
// ./client/models/content/notice.md
// module id = 442
// module chunks = 0